



































import { Component, Vue } from "vue-property-decorator";
import { CopyStyle } from "@/services/styles/types";
import { copyChannelStyle } from "@/services/styles/channelStylesService";

@Component
export default class ChannelStylesCopyModal extends Vue {
    model = {} as CopyStyle;
    name = "";

    open(id: string, name: string) {
        this.model.id = id;
        this.model.name = name + " Copy";
        this.name = name;
        this.$bvModal.show("modal-styleCopy");
    }

    confirm() {
        this.$bvModal.hide("modal-styleCopy");
        copyChannelStyle(this.model).then(() => {
            this.$emit("reload");
        });
        this.model = {} as CopyStyle;
    }

    decline() {
        this.$bvModal.hide("modal-styleCopy");
    }
}
